import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { green, amber } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { styled } from '@mui/material/styles';
import { CLOSE_NOTIFICATION } from '#action/types';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

const StyledSnackbarContent = styled(SnackbarContent, {
  shouldForwardProp: prop => prop !== 'variant'
})(({ theme, variant }) => ({
  ...(variant === 'success' && { backgroundColor: green[600] }),
  ...(variant === 'error' && { backgroundColor: theme.palette.error.dark }),
  ...(variant === 'info' && { backgroundColor: amber[700] }),
  ...(variant === 'warning' && { backgroundColor: amber[700], color: 'rgba(0, 0, 0, 0.87)' })
}));

const StyledVariantIcon = styled('span')(({ theme }) => ({
  fontSize: 20,
  color: '#FFF',
  opacity: 0.9,
  marginRight: theme.spacing(),
  display: 'flex'
}));

const MessageContainer = styled('span')({
  display: 'flex',
  alignItems: 'center'
});

const StyledCloseIcon = styled(CloseIcon)({
  fontSize: 20,
  color: '#FFF'
});

function MySnackbarContent(props) {
  const { message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <StyledSnackbarContent
      variant={variant}
      aria-describedby="client-snackbar"
      message={
        <MessageContainer
          id="client-snackbar"
          // Fixes issue with google site translator
          translate="no"
        >
          <StyledVariantIcon as={Icon} />
          {message}
        </MessageContainer>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          onClick={onClose}
        >
          <StyledCloseIcon />
        </IconButton>
      ]}
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired
};

class CustomizedSnackbars extends React.Component {
  handleClose = (e, reason) => {
    // do not close on the immediate serial call
    if (reason !== 'clickaway') {
      this.props.dispatch({
        type: CLOSE_NOTIFICATION
      });
    }
  };

  render() {
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={this.props.open}
          autoHideDuration={6000}
          onClose={this.handleClose}
        >
          <div>
            <MySnackbarContent
              onClose={this.handleClose}
              variant={this.props.variant}
              message={this.props.message}
            />
          </div>
        </Snackbar>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state.notification;
}

export default connect(mapStateToProps)(CustomizedSnackbars);
